import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { OrganizationSelectors } from 'Redux/modules/organization/selectors';
import { OrganizationActions } from 'Redux/modules/organization/actions';

const useIPWhitelist = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(OrganizationActions.ipWhitelistFetch());
  }, [dispatch]);

  const { loading, whitelist, enabled } = useSelector(OrganizationSelectors.organizationIPWhitelistSelector);
  return { loading, whitelist: whitelist || [], enabled };
};

export default useIPWhitelist;
